import { createSlice } from '@reduxjs/toolkit';
import uniq from 'lodash/uniq';
import { FetchStatus, SchemaKeys } from '../core';
const initialState = {
    items: {
        myTasks: [],
        myCompanyTasks: []
    },
    itemsFetchStatus: FetchStatus.None
};
const homeSlice = createSlice({
    name: SchemaKeys.Home,
    initialState,
    reducers: (create)=>({
            saveHomeResponse: create.reducer((state, { payload: { data, fetchStatus } })=>{
                return {
                    ...state,
                    items: {
                        ...data.result
                    },
                    itemsFetchStatus: fetchStatus
                };
            }),
            saveCompanyTasks: create.reducer((state, { payload })=>{
                var _state_items_myCompanyTasks;
                const myCompanyTasks = uniq([
                    ...(_state_items_myCompanyTasks = state.items.myCompanyTasks) !== null && _state_items_myCompanyTasks !== void 0 ? _state_items_myCompanyTasks : [],
                    ...payload
                ]);
                return {
                    ...state,
                    items: {
                        ...state.items,
                        myCompanyTasks
                    }
                };
            }),
            fetchHomeResponseError: create.reducer((state)=>{
                return {
                    ...state,
                    itemsFetchStatus: FetchStatus.Loaded
                };
            }),
            removeTask: create.reducer((state, { payload: taskId })=>{
                var _state_items_myCompanyTasks;
                return {
                    ...state,
                    items: {
                        ...state.items,
                        myTasks: state.items.myTasks.filter((t)=>t !== taskId),
                        myCompanyTasks: ((_state_items_myCompanyTasks = state.items.myCompanyTasks) !== null && _state_items_myCompanyTasks !== void 0 ? _state_items_myCompanyTasks : []).filter((t)=>t !== taskId)
                    }
                };
            })
        })
});
export const homeReducer = homeSlice.reducer;
export const homeStateName = homeSlice.name;
export const { saveHomeResponse, saveCompanyTasks, fetchHomeResponseError, removeTask } = homeSlice.actions;
